import { useMutation } from '@apollo/client';
import { Button, Form, Select as AntdSelect, Space, Typography } from 'antd';
import React, { useEffect } from 'react';
import {
  MODULE_TYPES,
  SPACER_OPTIONS,
  STATUS_TYPES
} from '../../../../../common/constants';
import { FORM_TYPES } from '../../../context/EditPageProvider';
import {
  CREATE_PAGE_MODULE,
  UPDATE_PAGE_MODULE
} from '../../../graphql/Mutations';
import { ModuleFields, Permissions } from './FormInputs';

const initialValues = {
  title: '',
  description: '',
  status: STATUS_TYPES.PUBLISHED,
  permissions: [],
  config: {
    desktop: 's-0',
    mobile: 's-0',
    tablet: 's-0',
    tv: 's-0'
  }
};
const MODULE_KEYS = {
  [MODULE_TYPES.SPACER]: 'spacerModule'
};

const CONFIG_TITLE = {
  [MODULE_TYPES.SPACER]: 'Spacing Configs'
};

const CONFIGS = [
  { label: 'Desktop', name: 'desktop' },
  { label: 'Mobile', name: 'mobile' }
  // { label: 'Tablet', name: 'tablet' },
  // { label: 'TV', name: 'tv' }
];

const SpacerForm = ({
  form: { type: formType, moduleId, defaultValues, index: order },
  pageId,
  type,
  onCancel,
  onSuccess
}) => {
  const [form] = Form.useForm();
  const isEdit = formType === FORM_TYPES.EDIT;

  const [addEditModule, { loading }] = useMutation(
    isEdit ? UPDATE_PAGE_MODULE : CREATE_PAGE_MODULE
  );

  useEffect(() => {
    if (moduleId && defaultValues && formType === FORM_TYPES.EDIT && form) {
      form.setFieldsValue({
        title: defaultValues?.title ?? '',
        description: defaultValues?.description ?? '',
        status: defaultValues?.status ?? STATUS_TYPES.DRAFT,
        permissions:
          defaultValues?.permissions?.map((value) => ({
            label: value,
            value
          })) ?? [],
        config: {
          desktop: defaultValues?.moduleData?.config?.desktop,
          mobile: defaultValues?.moduleData?.config?.mobile,
          tablet: defaultValues?.moduleData?.config?.tablet,
          tv: defaultValues?.moduleData?.config?.tv
        }
      });
    }
  }, [form, moduleId, formType, defaultValues, form]);

  const handleSubmit = ({ config, permissions, ...rest }) => {
    const key = MODULE_KEYS[type];
    if (!key) return;

    const payload = {
      ...(!isEdit && {
        type,
        order: order + 1
      }),
      permissions: permissions?.map(({ value }) => value),
      ...rest,
      [key]: {
        config
      }
    };

    addEditModule({
      variables: { data: payload, id: isEdit ? moduleId : pageId }
    }).then(
      ({
        data: {
          addUpdatedPageModule: { pageModule }
        }
      }) => {
        onSuccess(pageModule);
      }
    );
  };

  return (
    <Form
      layout="vertical"
      form={form}
      onFinish={handleSubmit}
      initialValues={initialValues}
    >
      <ModuleFields />
      <Space className="w-full" direction="vertical">
        <Space className="w-full" direction="vertical">
          <Typography.Text>{CONFIG_TITLE[type]}</Typography.Text>
          <div>
            {CONFIGS?.map(({ label, name }) => (
              <Form.Item key={name} label={label} name={['config', name]}>
                <AntdSelect options={SPACER_OPTIONS} />
              </Form.Item>
            ))}
          </div>
        </Space>
        <Permissions />
        <div className="d-flex button-section">
          <Space>
            <Form.Item>
              <Button
                type="text"
                htmlType="submit"
                className="text-btn mr-8"
                size="middle"
                disabled={loading}
                loading={loading}
              >
                Save
              </Button>
            </Form.Item>

            <Form.Item>
              <Button
                disabled={loading}
                onClick={onCancel}
                type="text"
                className="text-btn2"
              >
                Cancel
              </Button>
            </Form.Item>
          </Space>
        </div>
      </Space>
    </Form>
  );
};

export default SpacerForm;
